import type { CvData, CvSectionKey } from '@/types/cv';

export function orderedSections(data: CvData): CvSectionKey[] {
  const defaults: CvSectionKey[] = [
    'experience',
    'education',
    'skills',
    'languages',
    'projects',
    'certifications',
    'customSections',
  ];
  const config = data.settings.sectionOrder;
  if (!config || config.length === 0) return defaults;
  return [...config]
    .filter((s) => s.visible)
    .sort((a, b) => a.order - b.order)
    .map((s) => s.key);
}

export function isSectionEmpty(data: CvData, key: CvSectionKey): boolean {
  switch (key) {
    case 'experience':
      return data.experience.length === 0;
    case 'education':
      return data.education.length === 0;
    case 'skills':
      return data.skills.length === 0;
    case 'languages':
      return data.languages.length === 0;
    case 'projects':
      return !data.projects || data.projects.length === 0;
    case 'certifications':
      return !data.certifications || data.certifications.length === 0;
    case 'customSections':
      return !data.customSections || data.customSections.length === 0;
    default:
      return true;
  }
}

export function hasContact(data: CvData): boolean {
  const p = data.personalInfo;
  return Boolean(
    p.email || p.phone || p.address?.city || p.address?.country || (p.websites?.length ?? 0) > 0,
  );
}

export function fullName(data: CvData): string {
  return [data.personalInfo.firstName, data.personalInfo.lastName].filter(Boolean).join(' ').trim();
}
